import { Theme, ThemeProvider } from "@mui/material";
import { confirmable, ConfirmDialog, createConfirmation } from "react-confirm";

import { DeleteConfirmation } from "@/Components/v2/molecule/ConfirmationDialog";

interface ConfirmationProps {
  title?: string;
  subtitle?: string;
  deleteButtonText?: string;
  cancelButtonText?: string;
  theme: Theme;
}

const UnsavedChangesDialog: ConfirmDialog<ConfirmationProps, boolean> = ({
  show,
  proceed,
  title = "You have unsaved changes",
  subtitle = "There are unsaved changes on this page. To avoid losing your work, go back and save your changes before continuing.",
  deleteButtonText = "Discard Changes",
  cancelButtonText = "Go Back",
  theme,
}) => (
  <ThemeProvider theme={theme}>
    <DeleteConfirmation
      open={show}
      title={title}
      subtitle={subtitle}
      deleteButtonText={deleteButtonText}
      cancelButtonText={cancelButtonText}
      onDelete={() => proceed(true)}
      onCancel={() => proceed(false)}
    />
  </ThemeProvider>
);

const ConfirmableDialog = confirmable(UnsavedChangesDialog);

export const confirmUnsavedChanges = createConfirmation(ConfirmableDialog);
